import { Module } from "vuex";
import { RootState } from "../types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { RapportState } from "./types";

export const state: RapportState = {
  userId: localStorage.user ? JSON.parse(localStorage.user).id : "",
  rapport: undefined,
  selectedFavoris: "",
  periode: 0,
  typePeriode: "",
  allReports: localStorage.allReports
    ? JSON.parse(localStorage.allReports)
    : [],
  metrics: localStorage.metrics
    ? JSON.parse(localStorage.metrics)
    : [],
  favoris: localStorage.favoris ? JSON.parse(localStorage.favoris) : [],
  newFav: undefined,
  isNewFav: false,
};

const namespaced: boolean = true;

export const rapport: Module<RapportState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
